import React from "react";
import Dropdown from "../Dropdown/Dropdown.jsx";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../Context/AppContext.jsx";
import userHasPermission from "../../helpers/formTools/userHasPermission/index.js";

export default function DataDropdown(props) {
  const { defaultSelected } = props;
  const { userProfile} = useAppContext();
  const organization = JSON.parse(localStorage.getItem("organization"));
  const navigate = useNavigate();
  const dropdownItems = [];

  if(userHasPermission({
    userProfile,
    organization,
    resource: "REPERTO",
    permission: "READ",
  })) {
    dropdownItems.push({
      label: "REPERTI",
      onClick: () => {
        navigate("/reperti");
      },
    });
  }

  if(userHasPermission({
    userProfile,
    organization,
    resource: "BIBLIOGRAFIA",
    permission: "READ",
  })) {
    dropdownItems.push({
      label: "PUBBLICAZIONI",
      onClick: () => {
        navigate("/pubblicazioni");
      },
    });
  }

  if(userHasPermission({
    userProfile,
    organization,
    resource: "ARCHIVIOSTORICO",
    permission: "READ",
  })) {
    dropdownItems.push({
      label: "ARCHIVIO STORICO",
      onClick: () => {
        navigate("/archivio");
      },
    });
  }

  if(userHasPermission({
    userProfile,
    organization,
    resource: "MOVIMENTAZIONE",
    permission: "READ",
  })) {
    dropdownItems.push({
      label: "MOVIMENTAZIONE",
      onClick: () => {
        navigate("/movimentazione");
      },
    });
  }

  if(userHasPermission({
    userProfile,
    organization,
    resource: "DEPOSITO",
    permission: "READ",
  })) {
    dropdownItems.push({
      label: "DEPOSITI",
      onClick: () => {
        navigate("/deposito");
      },
    });
  }

  if(userHasPermission({
    userProfile,
    organization,
    resource: "CASSETTA",
    permission: "READ",
  })) {
    dropdownItems.push({
      label: "CASSETTE",
      onClick: () => {
        navigate("/cassette");
      },
    });
  }

  return (
    <Dropdown
      dropdownTexts={dropdownItems}
      defaultSelected={defaultSelected}
    />
  );
}
